import { logEvent as firebaseLogEvent } from 'firebase/analytics'
import { analyticsPromise } from './firebase'

async function log(event: string, params?: Record<string, unknown>) {
  const analytics = await analyticsPromise
  if (analytics) {
    firebaseLogEvent(analytics, event, params)
  }
}

// ── Screen Views ──

export function logScreenView(screen: string) {
  log('screen_view', { firebase_screen: screen })
}

// ── Receipt / OCR ──

export function logOcrAttempted(venueId: string) {
  log('ocr_attempted', { venue_id: venueId })
}

export function logOcrSuccess(venueId: string) {
  log('ocr_success', { venue_id: venueId })
}

export function logOcrFailed(venueId: string, error: string) {
  log('ocr_failed', { venue_id: venueId, error })
}

export function logOcrSkipped(venueId: string) {
  log('ocr_skipped', { venue_id: venueId })
}

export function logReceiptRetry(venueId: string) {
  log('receipt_retry', { venue_id: venueId })
}

// ── Amount Confirmation ──

export function logAmountEdited(ocrAmount: number, finalAmount: number) {
  log('amount_edited', { ocr_amount: ocrAmount, final_amount: finalAmount })
}

// ── Tip Selection ──

export function logTipSelected(option: string, percent: number | null, amount: number) {
  log('tip_selected', { tip_option: option, tip_percent: percent, tip_amount: amount })
}

// ── Payment ──

export function logPaymentStarted(amount: number, tipAmount: number, venueId: string, source: string) {
  log('payment_started', { amount, tip_amount: tipAmount, venue_id: venueId, source })
}

export function logPaymentCompleted(transactionId: string, amount: number, venueId: string) {
  log('payment_completed', { transaction_id: transactionId, amount, venue_id: venueId })
}

// ── Session ──

export function logSessionStarted(venueId: string) {
  log('session_started', { venue_id: venueId })
}
